var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg66(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7084_290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2031 21.8531L17.6813 16.3312C19.05 14.6625 19.875 12.525 19.875 10.1953C19.875 4.85156 15.5391 0.515625 10.1953 0.515625C4.84688 0.515625 0.515625 4.85156 0.515625 10.1953C0.515625 15.5391 4.84688 19.875 10.1953 19.875C12.525 19.875 14.6578 19.0547 16.3266 17.6859L21.8484 23.2031C22.2234 23.5781 22.8281 23.5781 23.2031 23.2031C23.5781 22.8328 23.5781 22.2234 23.2031 21.8531ZM10.1953 17.9484C5.91562 17.9484 2.4375 14.4703 2.4375 10.1953C2.4375 5.92031 5.91562 2.4375 10.1953 2.4375C14.4703 2.4375 17.9531 5.92031 17.9531 10.1953C17.9531 14.4703 14.4703 17.9484 10.1953 17.9484Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7084_290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg66);
export default __webpack_public_path__ + "static/media/svg66.58811792ec9085ab7f4bd16c824b0e08.svg";
export { ForwardRef as ReactComponent };